import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { packageContext as packageContextPropType } from 'lib/CustomPropTypes';

const chromelessRestrictedPackages = ['localNews'];

/**
 * PackageContext is a wrapper component that provides contextual data
 * to package components and conditionally renders them based on the application's
 * chromeless state.
 */
class PackageContext extends React.Component {
  static propTypes = {
    ...packageContextPropType,
    children: PropTypes.node.isRequired,
    packageType: PropTypes.string,
    isChromeless: PropTypes.bool.isRequired,
  };

  static childContextTypes = {
    ...packageContextPropType,
  };

  /* eslint-disable react/default-props-match-prop-types */
  static defaultProps = {
    packageIndex: null,
    zone: null,
    zonePackageTypes: [],
    isRailAdjacent: null,
    railContext: null,
  };
  /* eslint-disable react/default-props-match-prop-types */

  getChildContext() {
    const {
      packageIndex,
      zone,
      zonePackageTypes,
      isRailAdjacent,
      railContext,
      topOfPagePackages,
      pkgTitleColorIndex,
    } = this.props;

    return {
      packageIndex,
      zone,
      zonePackageTypes,
      isRailAdjacent,
      railContext,
      topOfPagePackages,
      pkgTitleColorIndex,
    };
  }

  render() {
    const { packageType, isChromeless, children } = this.props;

    if (isChromeless && chromelessRestrictedPackages.includes(packageType)) {
      return null;
    }

    return children;
  }
}

/**
 * Maps the Redux state to the component's props, specifically checking
 * if the application is in chromeless mode.
 * @param {object} state - The Redux state.
 * @returns {object} - An object containing the isChromeless property.
 */
const mapStateToProps = (state) => ({
  isChromeless: state.shared.isChromeless,
});

export const PackageContextProvider = connect(mapStateToProps)(PackageContext);
